import { useEffect, useState } from 'react';
import { API_URL, getSelectedProfileId } from '../utils';

export default function useFilmDetail(slug) {
  const [film, setFilm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFilmDetail = async () => {
      if (!slug) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const profileId = getSelectedProfileId();

        console.log('🎬 Fetching film detail for slug:', slug);

        // Fetch film by slug with profile ID
        const url = profileId
          ? `${API_URL}/api/videos/?profile_id=${profileId}&skip=0&limit=100`
          : `${API_URL}/api/videos/?skip=0&limit=100`;

        const response = await fetch(url, {
          headers: {
            accept: 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch film detail');
        }

        const videos = await response.json();

        // Find the film with matching slug
        const foundFilm = videos.find((video) => video.slug === slug);

        if (foundFilm) {
          console.log('✅ Film found:', foundFilm.title);
          setFilm(foundFilm);
        } else {
          console.warn('⚠️ Film not found with slug:', slug);
          setError('Film not found');
        }
      } catch (err) {
        console.error('❌ Error fetching film detail:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFilmDetail();
  }, [slug]);

  return { film, loading, error };
}
